module.exports = __webpack_public_path__ + "img/floor5_bg.3df63e00.png";